import { apiClient } from '~/shared/api/data-ingestion-api'
import { DOCUMENT_SERVER_STATUS } from '../config'

export function getDocumentStatus({
  status,
  hasReviewer,
  isAutoReviewedEnabled = false,
}: {
  status: apiClient.ReviewStatusEnum
  hasReviewer: boolean
  isAutoReviewedEnabled?: boolean
}): 'awaiting' | 'inProgress' | 'finished' | 'rejected' | 'processing' | 'autoReviewed' {
  if (status === DOCUMENT_SERVER_STATUS.processing) {
    return 'processing'
  }
  if (status === DOCUMENT_SERVER_STATUS.pending) {
    if (hasReviewer) {
      return 'inProgress'
    }
    return 'awaiting'
  }
  if (status === DOCUMENT_SERVER_STATUS.auto_reviewed) {
    return isAutoReviewedEnabled ? 'autoReviewed' : 'finished'
  }
  if (status === DOCUMENT_SERVER_STATUS.reviewed) {
    return 'finished'
  }
  return 'rejected'
}
